export default __webpack_public_path__ + "static/media/photo--sm--wheel-11.3e90d0b2.jpg";